import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorimetry';

export class Colorimetry extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
